import { toast } from "react-toastify";
import { resendVierifyOtpMail } from "../api/api";

export const requestOtp = async ({
  email,
  setLoading,
  setTimer,
  type = "resendOtp",
}) => {
  if (!email) {
    toast.error("Please enter your email address first");
    return false;
  }

  if (setLoading) setLoading(true);

  try {
    const response = await resendVierifyOtpMail({
      email,
      type,
    });

    if (
      response?.data?.success ||
      response?.success ||
      response?.status === 200 ||
      response?.status === true ||
      response?.status === "success" ||
      (response?.message && response.message.toLowerCase().includes("sent")) ||
      (response?.data?.message && response.data.message.toLowerCase().includes("sent"))
    ) {
      toast.success(
        response?.message ||
        response?.data?.message ||
        "OTP Sent Successfully!"
      );
      if (setTimer) setTimer(120);
      return true;
    } else {
      toast.error(
        response?.data?.message || response?.message || "Failed to send OTP"
      );
      return false;
    }
  } catch (error) {
    console.error("Error requesting OTP:", error);
    toast.error("Error sending OTP");
    return false;
  } finally {
    if (setLoading) setLoading(false);
  }
};
